/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var IdCardIcon20Light = forwardRef('IdCardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6Zm0 1h3v3H6V8Z" }),
        React.createElement("path", { d: "M11 8.5a.5.5 0 0 1 .5-.5H15a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M11.5 10a.5.5 0 0 0 0 1H15a.5.5 0 0 0 0-1h-3.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5ZM3 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" })));
});
